import axios from 'axios';

const api = axios.create({
  baseURL: '',
  withCredentials: true
});

api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers['X-API-Key'] = import.meta.env.VITE_INTERNAL_API_TOKEN;
  return config;
});

export default api;
